import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CountriesService } from 'src/app/services/countries.service';
import { GraphqlService } from 'src/app/services/graphql.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';
import { ApolloError } from '@apollo/client/errors';
import {
  Country,
  Provider_Allowed_Country
} from '../../../../../generated/graphql';
import { SelectItem } from 'primeng';
import { ProviderCountries } from 'src/app/models/provider';

@Component({
  selector: 'app-provider-countries',
  templateUrl: './provider-countries.component.html',
  styleUrls: ['./provider-countries.component.css']
})
export class ProviderCountriesComponent implements OnInit {
  providerCountries: Country[] = [];
  countries: SelectItem[] = [];
  selectedCountries: number[] = [];
  readonly displayedColumns: string[] = [
    //'Has National License',
    'Phone Code',
    'Name',
    'Acronym',
    'Currency Type'
  ];

  constructor(
    private readonly graphqlService: GraphqlService,
    private readonly providerstateService: ProviderStateService,
    private readonly countryService: CountriesService,
    private readonly changeDetector: ChangeDetectorRef
  ) {}

  providercountries: ProviderCountries = new ProviderCountries();
  addcountries: ProviderCountries = new ProviderCountries();
  deletecountries: ProviderCountries = new ProviderCountries();
  allcountries: ProviderCountries = new ProviderCountries();

  async ngOnInit() {
    this.countries = await this.getAllCountries();
    this.getProviderCountries();
  }

  getProviderCountries() {
    const providerId = this.providerstateService.getProviderId();
    return this.graphqlService
      .fetchAllowedCountries(providerId)
      .subscribe((result) => {
        this.providerCountries = result.data.fetchAllowedCountries.map(
          (allowedCountry) => allowedCountry.country
        );
        this.changeDetector.detectChanges();
      },(error: ApolloError) => {
        if (error.graphQLErrors) {
          for (const graphQLError of error.graphQLErrors) {
            if (graphQLError.extensions.code === 'BAD_REQUEST') {
              const messages: string[] = graphQLError.extensions.originalError.message
              this.providercountries.create_api_result.ServerError.error = messages.join(",")
              this.providercountries.create_api_result.ServerError.message = messages
              this.providercountries.create_api_result.ServerError.statusCode = 400
            }
            else if (graphQLError.extensions.code === 'INTERNAL_SERVER_ERROR') {
              const messages: string[] = [graphQLError.message]
              this.providercountries.create_api_result.ServerError.error = messages.join(",")
              this.providercountries.create_api_result.ServerError.message = messages
              this.providercountries.create_api_result.ServerError.statusCode = 400
            }
            else {
              const messages: string[] = ['Something went wrong!!']
              this.providercountries.create_api_result.ServerError.error = null
              this.providercountries.create_api_result.ServerError.message = messages
              this.providercountries.create_api_result.ServerError.statusCode = 500
            }
          }
        } else if (error.networkError) {
          const messages: string[] = ['Network Error']
          this.providercountries.create_api_result.ServerError.error = messages.join(",")
          this.providercountries.create_api_result.ServerError.message = messages
          this.providercountries.create_api_result.ServerError.statusCode = 500
        }

        this.providercountries.create_api_result.PromiseResult.success = false;
        this.providercountries.create_api_result.Posting = false;
        this.changeDetector.detectChanges();
      });
  }

  getAllCountries() {
    return this.countryService
      .getAllCountries()
      .toPromise()
      .then((countries) =>
        countries.map((element) => ({
          label: element.country_name,
          value: element.id
        }))
      )
      .catch((error: ApolloError) => {
        if (error.graphQLErrors) {
          for (const graphQLError of error.graphQLErrors) {
            if (graphQLError.extensions.code === 'BAD_REQUEST') {
              const messages: string[] = graphQLError.extensions.originalError.message
              this.allcountries.create_api_result.ServerError.error = messages.join(",")
              this.allcountries.create_api_result.ServerError.message = messages
              this.allcountries.create_api_result.ServerError.statusCode = 400
            }
            else if (graphQLError.extensions.code === 'INTERNAL_SERVER_ERROR') {
              const messages: string[] = [graphQLError.message]
              this.allcountries.create_api_result.ServerError.error = messages.join(",")
              this.allcountries.create_api_result.ServerError.message = messages
              this.allcountries.create_api_result.ServerError.statusCode = 400
            }
            else {
              const messages: string[] = ['Something went wrong!!']
              this.allcountries.create_api_result.ServerError.error = null
              this.allcountries.create_api_result.ServerError.message = messages
              this.allcountries.create_api_result.ServerError.statusCode = 500
            }
          }
        } else if (error.networkError) {
          const messages: string[] = ['Network Error']
          this.allcountries.create_api_result.ServerError.error = messages.join(",")
          this.allcountries.create_api_result.ServerError.message = messages
          this.allcountries.create_api_result.ServerError.statusCode = 500
        }

        this.allcountries.create_api_result.PromiseResult.success = false;
        this.allcountries.create_api_result.Posting = false;
        this.changeDetector.detectChanges();
        return [];
      });
  }

  deleteCountry(countryId: number) {
    this.graphqlService
      .removeAllowedCountry(Number(countryId))
      .subscribe(() => {
        this.getProviderCountries();
        this.changeDetector.detectChanges();
      }, (error: ApolloError) => {
        if (error.graphQLErrors) {
          for (const graphQLError of error.graphQLErrors) {
            if (graphQLError.extensions.code === 'BAD_REQUEST') {
              const messages: string[] = graphQLError.extensions.originalError.message
              this.deletecountries.create_api_result.ServerError.error = messages.join(",")
              this.deletecountries.create_api_result.ServerError.message = messages
              this.deletecountries.create_api_result.ServerError.statusCode = 400
            }
            else if (graphQLError.extensions.code === 'INTERNAL_SERVER_ERROR') {
              const messages: string[] = [graphQLError.message]
              this.deletecountries.create_api_result.ServerError.error = messages.join(",")
              this.deletecountries.create_api_result.ServerError.message = messages
              this.deletecountries.create_api_result.ServerError.statusCode = 400
            }
            else {
              const messages: string[] = ['Something went wrong!!']
              this.deletecountries.create_api_result.ServerError.error = null
              this.deletecountries.create_api_result.ServerError.message = messages
              this.deletecountries.create_api_result.ServerError.statusCode = 500
            }
          }
        } else if (error.networkError) {
          const messages: string[] = ['Network Error']
          this.deletecountries.create_api_result.ServerError.error = messages.join(",")
          this.deletecountries.create_api_result.ServerError.message = messages
          this.deletecountries.create_api_result.ServerError.statusCode = 500
        }

        this.deletecountries.create_api_result.PromiseResult.success = false;
        this.deletecountries.create_api_result.Posting = false;
        this.changeDetector.detectChanges();
      });
  }

  addCountry() {
    if (!this.selectedCountries.length) return;
  
    this.graphqlService
      .addAllowedCountryForProvider(this.selectedCountries)
      .subscribe((res) => {
        this.getProviderCountries();
        this.changeDetector.detectChanges();
        this.selectedCountries = [];
      },(error: ApolloError) => {
        if (error.graphQLErrors) {
          for (const graphQLError of error.graphQLErrors) {
            if (graphQLError.extensions.code === 'BAD_REQUEST') {
              const messages: string[] = graphQLError.extensions.originalError.message
              this.addcountries.create_api_result.ServerError.error = messages.join(",")
              this.addcountries.create_api_result.ServerError.message = messages
              this.addcountries.create_api_result.ServerError.statusCode = 400
            }
            else if (graphQLError.extensions.code === 'INTERNAL_SERVER_ERROR') {
              const messages: string[] = [graphQLError.message]
              this.addcountries.create_api_result.ServerError.error = messages.join(",")
              this.addcountries.create_api_result.ServerError.message = messages
              this.addcountries.create_api_result.ServerError.statusCode = 400
            }
            else {
              const messages: string[] = ['Something went wrong!!']
              this.addcountries.create_api_result.ServerError.error = null
              this.addcountries.create_api_result.ServerError.message = messages
              this.addcountries.create_api_result.ServerError.statusCode = 500
            }
          }
        } else if (error.networkError) {
          const messages: string[] = ['Network Error']
          this.addcountries.create_api_result.ServerError.error = messages.join(",")
          this.addcountries.create_api_result.ServerError.message = messages
          this.addcountries.create_api_result.ServerError.statusCode = 500
        }

        this.addcountries.create_api_result.PromiseResult.success = false;
        this.addcountries.create_api_result.Posting = false;
        this.changeDetector.detectChanges();
      });
  }
}
